import {AppBar} from '@ezcater/store-ui';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { SIGN_IN_PATH, consumerCartProps, startNewOrderPath } from './consumerCartUtils';
import RootProvider from '../providers/RootProvider';

const homeHeader = document.getElementById('nav-bar-container-home');
const storeHeader = document.getElementById('nav-bar-container-store');
const dataElement = homeHeader ?? storeHeader;
const currentUserJson = dataElement?.dataset?.currentUser

let currentUser = currentUserJson ? JSON.parse(currentUserJson) : undefined;
if (!currentUser?.id) {
  currentUser = undefined;
}

let supportPhoneNumber = dataElement?.dataset?.supportPhoneNumber ?? '';
let supportFaxNumber = dataElement?.dataset?.supportFaxNumber ?? '';
let showFullNavBar = dataElement?.dataset?.showFullNavBar ?? false;
let corpPortalHost = dataElement?.dataset?.corpPortalHost;

const clickTrackingHandler = (elementName: string, eventLabel: string) => {
  // @ts-ignore
  if (window.EzCater && window.EzCater.EventTracking) {
    // @ts-ignore
    EzCater.EventTracking.registerCustomPageProps({
      event: 'track_event_nav_bar',
      event_category: 'Navigation',
      event_action: 'Header',
      event_label: eventLabel,
      event_value: 0,
      non_interaction: false,
    });
    // @ts-ignore
    EzCater.EventTracking.pageElementClicked({name: elementName});
  }
};

const mapContactType = (clickedText: string) => {
  if (!clickedText) return;

  let contactType = '';

  if (clickedText.includes('/company/contact-us/')) {
    contactType = 'send message';
  } else if (clickedText.includes('mailto')) {
    contactType = 'email';
  } else if (clickedText.includes('Chat')) {
    contactType = 'chat';
  } else if (clickedText.includes('tel')) {
    contactType = 'phone';
  } else if (clickedText.includes('fax')) {
    contactType = 'fax';
  }

  return contactType;
}

const contactUsPayload = ({misc_json}) => {
  const itemClicked = JSON.parse(misc_json)['item_clicked'];

  if (!itemClicked) {
    return {};
  }

  const clickedText = itemClicked.link || itemClicked.text || '';
  const contactType = mapContactType(clickedText);

  return {event: 'contact_us', contact_type: contactType};
};

const trackingCallback = (event: string, eventData: {url: string, name: string, misc_json: string}) => {
  // @ts-ignore
  EzCater.EventTracking.registerCustomPageProps({
    event,
    event_category: 'Navigation',
    event_action: 'Header',
    non_interaction: false,
    url: eventData.url,
    misc_json: eventData.misc_json,
  });
  // @ts-ignore
  EzCater.EventTracking.pageElementClicked({name: eventData.name});

  (window as any)?.dataLayer?.push(contactUsPayload(eventData));
}

const openLibertyChat = () => {
  // @ts-ignore
  window.LibertyWebchatClient?.toggleVisibility();
}

const defaultProps = {
  notificationCount: 0,
  notifications: undefined,
  supportPhoneNumber,
  supportFaxNumber,
  openLibertyChat,
  onStartNewOrderClick: () => clickTrackingHandler('start_new_order_button', 'Start New Order'),
  onMobileMenuButtonClick: () => clickTrackingHandler('mobile_menu_button', 'Mobile Menu Button'),
  track: trackingCallback,
};

const metaElement: HTMLMetaElement = document.querySelector('meta[name="__EZCATER_GATEWAY_URL__"]');
const federationUrl = metaElement?.content;

const appBarProps = {
  currentUser,
  federationUrl: federationUrl + "/graphql",
  startNewOrderPath: startNewOrderPath,
  loginPath: SIGN_IN_PATH,
  channelPartnerLogoUrl: currentUser?.corporateAccount?.channelPartnerLogoUrl,
  ...consumerCartProps,
  corpPortalHost,
};

if (homeHeader) {
  ReactDOM.render(<RootProvider><AppBar {...appBarProps} {...defaultProps} landingPage /></RootProvider>, homeHeader);
} else if (storeHeader) {
  ReactDOM.render(<RootProvider><AppBar {...appBarProps} {...defaultProps} simplified={!showFullNavBar} /></RootProvider>, storeHeader);
}
